/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Link, Typography } from "@material-ui/core";
import PostRequirementButtons from "./PostRequirementButtons";

import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  gridCardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: "100%",
      height: "30rem",
      margin: "0.5rem 0% 0.5rem 0%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: "28rem",
      margin: "0.5rem 0% 0.5rem 0%",
    },
    /* XSSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 170)]: {
      width: "100%",
      height: "31rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    /* XSSMSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 130)]: {
      width: "100%",
      height: "36rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    /* XSSMSMSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      width: "49%",
      height: "25rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "49%",
      height: "27rem",
      margin: "0.5rem 0.25% 0.5rem 0.25%",
    },
    /* SMMD Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.md - 80)]: {
      width: "32.33%",
      height: "23rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("md")]: {
      width: "32.33%",
      height: "26rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* MDLG Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg - 240)]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* LGXL Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl - 500)]: {
      width: "32.33%",
      height: "32rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* LGXLXL Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl - 50)]: {
      width: "32.33%",
      height: "36rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XLXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 80)]: {
      width: "32.33%",
      height: "34rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "32.33%",
      height: "29rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 670)]: {
      width: "32.33%",
      height: "36rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1280)]: {
      width: "32.33%",
      height: "42rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXLXXXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1780)]: {
      width: "32.33%",
      height: "44rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      width: "32.33%",
      height: "32rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    borderRadius: "4px",
    boxShadow:
      "0px 0px 2px rgb(0 0 0 / 14%), 0px 2px 2px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)",
    color: "#202020",
    "&:hover": {
      textDecoration: "none",
    },
  },
  gridCardInfoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "0.5rem 1rem 0.5rem 1rem",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
  },
  propertyTitle: {
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    padding: "0rem 0rem 1rem 0rem",
  },
  gridCardImage: {
    marginTop: "1rem",
    [theme.breakpoints.up("lg")]: {
      marginTop: "2rem",
      marginBottom: "3.5rem",
    },
    width: "100%",
    height: "auto",
  },
}));

const PostRequirementCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Link
        href="/postrequirement"
        rel="noopener"
        className={classes.gridCardContainer}
      >
        <div className={classes.gridCardImageContainer}>
          <img
            src={
              props.imageSrc
                ? props.imageSrc
                : "/images/other/postrequirement.svg"
            }
            alt={AppConfig.imageAltText}
            width={300}
            height={279}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.gridCardImage}
          />
        </div>
        <div className={classes.gridCardInfoContainer}>
          <Typography
            variant="body2"
            component="span"
            className={classes.propertyTitle}
          >
            Couldn’t find your dream property? Contact us or give us your exact
            requirements
          </Typography>
          <PostRequirementButtons />
        </div>
      </Link>
    </React.Fragment>
  );
};

export default PostRequirementCard;
